import { render, staticRenderFns } from "./vrCompanyProperty.vue?vue&type=template&id=0156525b"
import script from "./vrCompanyProperty.vue?vue&type=script&lang=js"
export * from "./vrCompanyProperty.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports